import { ReactElement, useState } from 'react';
import { space } from '@op/opds.tokens';
import { Message, useMessage } from '@messageformat/react';
import { Alert, Col, Row } from '@op/opds.opux';
import CourseTaskHeader from '../CourseTaskHeader';
import SegmentedButtonQuestionTile from '../SegmentedButtonQuestionTile';
import { getMsgValues } from '../../utils';

const TaskOne = (): ReactElement => {
  const options1 = getMsgValues(useMessage('course3.task1.question1.options'));
  const options2 = getMsgValues(useMessage('course3.task1.question2.options'));
  const options3 = getMsgValues(useMessage('course3.task1.question3.options'));
  const options4 = getMsgValues(useMessage('course3.task1.question4.options'));
  const options5 = getMsgValues(useMessage('course3.task1.question5.options'));
  const options6 = getMsgValues(useMessage('course3.task1.question6.options'));

  const [correctAnswers, setCorrectAnswers] = useState(Array(6).fill(false));

  const COURSE_NUMBER = 3;
  const TASK_NUMBER = 1;

  const updateAnswers = (value: 1 | 2 | 3 | 4 | 5 | 6) => {
    return (isCorrect: boolean): void => {
      const newAnswers = [...correctAnswers];
      newAnswers[value - 1] = isCorrect;
      setCorrectAnswers(newAnswers);
    };
  };

  return (
    <div style={{ marginTop: space.xxl }}>
      <CourseTaskHeader questionNumber={1} totalQuestions={2} />
      <h3
        className="opds-styles-v1-text-hero-small"
        style={{ textAlign: 'center', marginTop: space.xxl }}
      >
        <Message id="course3.task1.title" />
      </h3>
      <div
        className="opds-styles-v1-text-body-medium"
        style={{
          textAlign: 'center',
          paddingBottom: space.default,
          paddingTop: space.default,
        }}
      >
        <Message id="course3.task1.body" />
      </div>
      <Row style={{ marginTop: space.default, marginLeft: 0, marginRight: 0 }}>
        <Col
          style={{ display: 'flex', flexDirection: 'column' }}
          xs={12}
          md={6}
          className="investoracademy-multi-column-left-small-padding"
        >
          <SegmentedButtonQuestionTile
            courseNumber={COURSE_NUMBER}
            taskNumber={TASK_NUMBER}
            number="1"
            correctAnswer={options1[1]}
            options={options1}
            onAnswered={updateAnswers(1)}
          />
          <SegmentedButtonQuestionTile
            courseNumber={COURSE_NUMBER}
            taskNumber={TASK_NUMBER}
            number="2"
            correctAnswer={options2[0]}
            options={options2}
            onAnswered={updateAnswers(2)}
          />
          <SegmentedButtonQuestionTile
            courseNumber={COURSE_NUMBER}
            taskNumber={TASK_NUMBER}
            number="3"
            correctAnswer={options3[0]}
            options={options3}
            onAnswered={updateAnswers(3)}
          />
        </Col>
        <Col
          style={{ display: 'flex', flexDirection: 'column' }}
          xs={12}
          md={6}
          className="investoracademy-multi-column-right-small-padding"
        >
          <SegmentedButtonQuestionTile
            courseNumber={COURSE_NUMBER}
            taskNumber={TASK_NUMBER}
            number="4"
            correctAnswer={options4[0]}
            options={options4}
            onAnswered={updateAnswers(4)}
          />
          <SegmentedButtonQuestionTile
            courseNumber={COURSE_NUMBER}
            taskNumber={TASK_NUMBER}
            number="5"
            correctAnswer={options5[0]}
            options={options5}
            onAnswered={updateAnswers(5)}
          />
          <SegmentedButtonQuestionTile
            courseNumber={COURSE_NUMBER}
            taskNumber={TASK_NUMBER}
            number="6"
            correctAnswer={options6[1]}
            options={options6}
            onAnswered={updateAnswers(6)}
          />
        </Col>
      </Row>
      {correctAnswers.filter(Boolean).length === 6 && (
        <Alert type="positive">
          <Message id="answers_correct" />
        </Alert>
      )}
    </div>
  );
};

export default TaskOne;
